import { render } from "./LealtadRewardNew.vue?vue&type=template&id=fe205748&scoped=true"
import script from "./LealtadRewardNew.vue?vue&type=script&lang=js"
export * from "./LealtadRewardNew.vue?vue&type=script&lang=js"

import "./LealtadRewardNew.vue?vue&type=style&index=0&id=fe205748&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe205748"]])

export default __exports__